<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-9 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTipoTercero()">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row justify-content-center mt-3" v-if="tipoTerceros.length > 0">
            <div class="col-md-5">
                <b-table
                    :items="tipoTerceros"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="(item) => editTipoTercero(item.id)"
                >
                    <template #cell(tipo_tercero)="data">
                        <div class="text-right">{{ data.item.tipo_tercero }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="tipoTerceros.length"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
                <!-- <md-table md-card md-header v-model="tipoTerceros">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" @click="editTipoTercero(item.id)">
                        <md-table-cell :md-label="labels.codigo" class="border">{{ item.tipo_tercero }}</md-table-cell>
                        <md-table-cell :md-label="labels.descripcion" class="border text-left">{{ item.descripcion }}</md-table-cell>
                    </md-table-row>
                </md-table> -->
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showTipoTercero" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showEditTipoTercero" :infoEdit="dataTipoTercero" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import TipoTerceros from '../../../services/TipoTerceros'
import Crear from './Crear.vue'
import Editar from './Editar.vue'
export default {
    name:'TipoTerceros',
    components:{Crear,Editar},
    data: () => ({
        tipoTerceros : [],
        showTipoTercero : false,
        showEditTipoTercero : false,
        dataTipoTercero : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'tipo_tercero', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Tipo terceros",
                    codigo : "Código",
                    descripcion : "Descripción",
                    noRow : "No hay registros"
                }
            }else{
                return {
                    title: "Tipo terceros",
                    codigo : "Code",
                    descripcion : "Description",
                    noRow : "There are not records"
                }
            }
        }
    },
    methods:{
        createTipoTercero(){
            this.showTipoTercero = true
        },
        editTipoTercero(id){
            // console.log(id);
            TipoTerceros.getTipoTerceroById(id)
            .then((res) => {
                // console.log(res.data.tipoTercero)
                this.dataTipoTercero = res.data.tipoTercero
                this.showEditTipoTercero = true
            })
            .catch((err) => { console.log(err)})
        },
        closeModal(valor){
            this.showTipoTercero = valor
            this.showEditTipoTercero = valor
        }
    },
    mounted(){
        TipoTerceros.getAllTipoTerceros()
        .then((res) => {
            // console.log(res.data.listTipoTerceros)
            this.tipoTerceros = res.data.listTipoTerceros
        })
        .catch((err) => { console.log(err)})
    }
}
</script>

<style>

</style>